import ToggleButton from './ToggleButtonContainer';
import { TOGGLE_LEFT, TOGGLE_RIGHT } from './ToggleButtonDuck';

export { TOGGLE_LEFT, TOGGLE_RIGHT }

export default ToggleButton

